import React from 'react';
import { Box } from '@mui/material';
import {
    FaChartBar,
    FaExclamationTriangle,
    FaHeartbeat,
} from 'react-icons/fa'; 
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import IgdChartsContainer from '../Common/IgdChartsContainer';
import GeneralResultsWrapper from './IGD';
import ValuesWrapper from './Values';
import ConditionalityWrapper from './Conditionality';



const Results = (props) => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate(`/governanceroom/${props.dashboardPath}`);
    };

    const menus = [
        {
            title: 'IGD',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/igd`,
            icon: <FaChartBar style={{ marginRight: '5px' }} />
        },
        {
            title: 'Valores',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/values`,
            icon: <FaHeartbeat style={{ marginRight: '5px' }} />
        },
        {
            title: 'Condicionalidade',
            path: `/governanceroom/${props.dashboardPath}/${props.menuPath}/conditionality`,
            icon: <FaExclamationTriangle style={{ marginRight: '5px' }} />
        }
    ];
    
    const titleMap = {
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/igd`]:
            'Resultados Gerais dos Indicadores',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/Values`]:
            'Resultados dos Indicadores de Valores',
        [`/governanceroom/${props.dashboardPath}/${props.menuPath}/conditionality`]: 'Resultados dos Indicadores de Condicionalidade'
    };

    return (
        <Box>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <IgdChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="igd" replace />}
                        />
                        <Route
                            path="values"
                            element={<ValuesWrapper />}
                        />
                        <Route
                            path="igd"
                            element={<GeneralResultsWrapper />}
                        />
                        <Route
                            path="conditionality"
                            element={<ConditionalityWrapper />}
                        />
                    </Routes>
                </IgdChartsContainer>
            </Box>
        </Box>
    );
};

export default Results;
